import React,{ Component } from 'react';

import {Col,Row,Pagination} from 'react-bootstrap';
import Switch from 'react-toggle-switch';

import Container from '../../components/Container';
import Heading from '../../components/Heading';
import SentTable from './components/SentTable';

import Filters from './components/Filters';

import API from '../../services/API';


class Sent extends Component {
    constructor() {
        super();

        this.state = {
            pagesTotal: 0,
            activePage: 1,
            rows: [],
            filters: {},
            isLoading: false,
            isArchive: false
        };

        this.handlePageSelect = this.handlePageSelect.bind(this);
        this.handleFiltersSubmit = this.handleFiltersSubmit.bind(this);
        this.handleArchiveSwitchClick = this.handleArchiveSwitchClick.bind(this);

    }

    componentDidMount() {
        this.loadSent();
    }

    componentDidUpdate(nextProps,prevState) {
        if(this.state.filters !== prevState.filters || this.state.activePage !== prevState.activePage || this.state.isArchive !== prevState.isArchive) {
            this.loadSent();
        }
    }

    handleFiltersSubmit(filters) {
        console.log(filters);
        this.setState({filters,activePage:1});
    }

    handlePageSelect(activePage) {
        this.setState({activePage});
    }

    handleArchiveSwitchClick() {
        this.setState(prevState => {
            return {
                isArchive: !prevState.isArchive
            };
        });
    }


    loadSent() {
        const {activePage, filters, isArchive} = this.state;
        this.setState({
            isLoading: true
        });

        API.Notifications.getPage(activePage, filters, isArchive).then(res => {
            this.setState({
                ...res,
                isLoading: false
            });
        });
    }



    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="Sent"/>
                <Row>
                    <Col lg={12}>
                        <div>
                            <span>Archive </span>
                            <Switch onClick={this.handleArchiveSwitchClick} on={this.state.isArchive}></Switch>
                        </div>

                        <Filters
                            onSubmit={this.handleFiltersSubmit}
                        />
                        <SentTable sent={this.state.rows} isArchive={this.state.isArchive}/>
                    </Col>
                </Row>
                <Pagination
                    items={this.state.pagesTotal}
                    maxButtons={20}
                    onSelect={this.handlePageSelect}
                    activePage={this.state.activePage}
                />
            </Container>
        );
    }
}

export default Sent;


// WEBPACK FOOTER //
// ./src/scenes/Sent/index.js